import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {SecurityService} from '../services/security.service';

export function authBypassGuard(): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const securityService: SecurityService = inject(SecurityService);
    if (securityService.isLoggedIn()) {
      console.log('User already authenticated, redirecting to main menu')
      router.navigate(['/dashboard'])
      return false;
    }
    return true;
  };
}
